import getConfig from 'next/config'

export default getConfig()
